import BaseModel from "../base/baseModel";

import AreaAbrangenciaFaixaModel from "./areaAbrangenciaFaixaModel";

export default class AreaAbrangenciaModel extends BaseModel {
    id: number | null = null;
    descricao = "";
    percentual: number | null = null;
    areaAbrangenciaFaixas: Array<AreaAbrangenciaFaixaModel> = [];
}
